var path = 'templates/kula/message-toast.html';
var html = "<md-toast class=message-toast style=font-size:24px> <div class=user-info> <img ng-src=./resources/img/diamond.png style=width:25px;display:inline;vertical-align:middle> おしらせ </div> <div class=content> <span> {{msg}} </span> </div> </md-toast> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/templates/kula/message-toast.html
// module id = 29
// module chunks = 0